import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=5e2eaa8d&scoped=true"
import script from "./myheader.vue?vue&type=script&lang=js"
export * from "./myheader.vue?vue&type=script&lang=js"
import style0 from "./myheader.vue?vue&type=style&index=0&id=5e2eaa8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2eaa8d",
  null
  
)

export default component.exports